import { MAX_QUESTION_LENGTH, shouldShowCharCount } from "../lib/config";

/**
 * `length/limit` counter, shown once the value nears the limit so the layout
 * does not shift while typing. Turns red at the limit.
 */
export function CharCount({ length }: { length: number }) {
  if (!shouldShowCharCount(length)) return null;
  const atLimit = length >= MAX_QUESTION_LENGTH;
  return (
    <span
      class={`char-count${atLimit ? " char-count--limit" : ""}`}
      aria-label={`${length} of ${MAX_QUESTION_LENGTH} characters used`}
    >
      {length}/{MAX_QUESTION_LENGTH}
    </span>
  );
}
